module.exports = __webpack_public_path__ + "img/large.be5030ca.webp";